import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as layoutActions from "../../reducers/LayoutReducer/actions";
import {
  instalacionSelector,
  usuarioSelector,
  flagDatosAdicionalesSelector,
} from "../../selectors/sessionSelector";
import * as sessionActions from "../../reducers/SessionReducer/actions";
import * as pedidoActions from "../../reducers/PedidoReducer/actions";
import * as tuerneroActions from "../../reducers/TurneroReducer/actions";
import * as provLocActions from "../../reducers/ProvinciaLocalidadReducer/actions";
import * as Notification from "../../components/Common/notification";
import * as catalogoActions from "../../reducers/CatalogoReducer/actions";
import FinalizarCompra from "../../components/FinalizarCompra/";
import { pedidoDataSelector } from "../../selectors/pedidoSelector";
import { calendarioSelector } from "../../selectors/turneroSelector";
import { showModal } from "@smiledev/react-web-feedback";
import { sucursalesSelector } from "../../selectors/sucursalesSelector";
import CustomPaymentDialog from "../../components/Modals/Pagos/CustomPaymentDialog";
import { loadStencilComponents } from "../../components/Modals/Pagos/loadStencilComponents";
import { getPedidoById, getStatusPedidoById, updateEstadoPedidoById } from "../../sagas/PedidoSaga/calls";
import * as confirmarPedidoActions from "../../reducers/ConfirmarPedidoReducer/actions";
import { url_payment_gateway } from "../../config/paymentConfig";
import ModalSolicitudLocalidadEntrega from "../../components/DomicilioEntrega/ModalSolicitudLocalidadEntrega";
import { updateLocalidadEntregaCliente, GetLocalidadesEntregaActivas, getDomicilioLocalidadPreferenciaEntregaCliente } from "../../sagas/LocalidadEntregaSaga/calls";

// estados de pedido
const estadosPedido = {
  BORRADOR: 1,
  CONFIRMADO: 2,
  ELIMINADO: 6,
  PENDIENTE: 7,
};

const formaPagoOnline = {
  PagoAlRetirar: 1,
  MercadoPago: 2,
  Mobbex: 3,
  PagoAlRecibir: 4,
};

const preferenciaEntrega = {
  Pickup: 1,
  Delivery: 2,
};

class FinalizarCompraContainer extends React.Component {
  constructor(props) {
    super(props);

    window.scrollTo(0, 0);

    this.state = {
      pedidoCargado:
        this.props.dataPedido && this.props.dataPedido.pedido !== undefined
          ? true
          : false,
      pedidoData: null,
      reemplazarProductos: undefined,
      form: {
        telefono: '',
        documento: '',
      },
      formMercadoPago: {
        emailMercadoPago: '',
        informacionTarjeta: '',
        nombreEnTarjeta: '',
        fechavencimiento: '',
        codigoverificacion: '',
        cuotastarjeta: '1',
        tipodocumento: 'DNI',
        numerodocumento: '',
        paimentmethodid:'',
        paimenttypeid:'',
        installments:[{value:'',text:''}],
        //installmentDescriptions:[],
      },
      errores:{},
      showMetodosPago: undefined,
      usuarioCargado: false,
      openModal: true,
      pedidoCargado: false,
      openModalCompraExitosa: false,
      openModalPagoPendiente: false,
      timeExceeded: false,
      preferenciaEntregaElegida: false,
      entregaElegida: undefined,
      fechaSeleccionada: undefined,
      horaSeleccionada: undefined,
      permitePago: false,
      showTurnero: false,

      domicilioSeleccionado: undefined,
      domicilioSeleccionadoItem: undefined,
      ultimoDomicilioEntrega: undefined,
      idUltimoDomicilioEntrega: undefined,
      disabledPagar: false,
      verMasPedidosDetalle: false,

      tipoFacturacion: undefined,
      idClienteDatosFacturacion: undefined,

      sucursalesPickup: [],
      sucursalPickupSeleccionada: undefined,
      openCustomDialog: false,
      pedidoId: 0,
      pedidoPrecioFinal: 0,
      
      isDataLoaded: false,
      openModalSolicitudLocalidadEntrega: false,
      localidadSeleccionada: null,
      idLocalidadSeleccionada: null,
      localidadesEntregaActivas: [],
      localidadesCargadas: false,
      errorLocalidad: null,
      tieneDomiciliosSinLocalidad: false,
      domiciliosSinLocalidad: [], 
      domicilioPreferenciaCliente:null,
      previousDomicilioState: null,
      restorePreviousSelection: false
    };
    this.pollingInterval = null;
    this.pedidoActual = null;


    if (this.props.usuario === undefined) {
      window.location.hash = '/Login';
    } else {
      // obtengo el pedido
      let payload = {};
      payload.idUsuario = this.props.usuario.id;

      // payload.callbackFinalizarCompra = () => {
      //   window.location.hash = "/Login";
      // };

      this.props.sagaFetchPedidoBorrador(payload);

      this.props.setShowResumenPedido(false);
    }
  }

  componentWillMount = () => {
    this.props.setShowResumenPedido(false);

    const preferenciasPayload = {};
    preferenciasPayload.idCliente = this.props.usuario.idCliente;
    preferenciasPayload.callback = (preferencias) => {
      const {
        idTipoFacturacion,
        idClienteDatosFacturacion,
        domicilioEntrega,
        idDomicilioEntrega,
      } = preferencias;
      this.setState({
        tipoFacturacion: idTipoFacturacion,
        idClienteDatosFacturacion,
        ultimoDomicilioEntrega: domicilioEntrega,
        idUltimoDomicilioEntrega: idDomicilioEntrega,
      });
    };
    this.props.sagaGetPreferenciasUltimoPedido(preferenciasPayload);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.state.usuarioCargado === false &&
      this.props.usuario !== undefined
    ) {
      let form = {
        telefono: this.props.usuario.telefono
          ? this.props.usuario.telefono
          : "",
        documento: this.props.usuario.dni ? this.props.usuario.dni : "",
      };

      let domicilioSeleccionado = undefined;
      let showTurnero = false;
      if (
        this.props.usuario.domiciliosEntrega !== undefined &&
        this.props.usuario.domiciliosEntrega.length > 0
      ) {
        domicilioSeleccionado = this.props.usuario.domiciliosEntrega[0]
          .idDomicilioEntrega;
        showTurnero = true;
      }

      this.setState({
        form: form,
        usuarioCargado: true,
        domicilioSeleccionado: domicilioSeleccionado,
        showTurnero: showTurnero,
      });
    }

    if (
      this.state.pedidoCargado === false &&
      this.props.dataPedido &&
      this.props.dataPedido.pedido
    ) {
      this.setState({ pedidoCargado: true }, this.checkPermisosReemplazo);
    }

if (this.state.restorePreviousSelection && !prevState.restorePreviousSelection) {
  const { domicilioSeleccionado, domicilioSeleccionadoItem } = this.state;
  if (domicilioSeleccionado && domicilioSeleccionadoItem) {
    this.procesarSeleccionDomicilio(
      domicilioSeleccionado,
      domicilioSeleccionadoItem
    );
  }

  this.setState({ restorePreviousSelection: false });
}
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.sucursalesPickup.length === 0 && nextProps.sucursales) {
      let sucursales = [];
      nextProps.sucursales.map((sucursal) => {
        let formaEntrega = sucursal.formasDeEntrega.find(
          (x) => x.idFormaEntrega === 1
        );
        if (formaEntrega)
          sucursales.push({
            idSucursal: sucursal.idSucursal,
            nombre: sucursal.nombre,
            direccion: sucursal.direccion,
            porDefecto: formaEntrega.porDefecto,
          });
      });
      
      this.setState({
        sucursalesPickup: sucursales,
        sucursalPickupSeleccionada: undefined,
      });
    }
    this.render();
  }

  checkPermisosReemplazo = () => {
    if(this.props.dataPedido && this.props.dataPedido.pedido){
      let countTrue = 0
      let countFalse = 0
      this.props.dataPedido.pedido.listaPedidoDetalle.forEach((pd) => {
        if(pd.permisoReemplazo === true){
          countTrue = countTrue + 1
        }
        else{
          countFalse = countFalse + 1
        }
      });

      let cantidadPd = this.props.dataPedido.pedido.listaPedidoDetalle.length 

      if(countTrue === cantidadPd){
        this.setState({reemplazarProductos: "1"})
      }
      else if(countFalse === cantidadPd){
        this.setState({reemplazarProductos: "2"})
      }
      else{
        this.setState({reemplazarProductos: undefined})
      }
    }
  }
  getSucursalDefecto = (forma) => {
    // 1 es pickup, 2 es delivery
    let sucursales = [];
    this.props.sucursales.map((sucursal) => {
      let formaEntrega = sucursal.formasDeEntrega.find(
        (x) => x.idFormaEntrega === forma
      )
      if (formaEntrega)
        sucursales.push({
          idSucursal: sucursal.idSucursal,
          nombre: sucursal.nombre,
          direccion: sucursal.direccion,
          porDefecto: formaEntrega.porDefecto,
        });
    });
    
    // Si no hay sucursal anterior del usuario, tomar la con menor idSucursal
    if (forma === 1) {
      // Pickup
      return null;
    } else {
      // Delivery
      return this.props.usuario.ultimaSucursalDelivery ||
        (sucursales.length > 0 
          ? sucursales.reduce((prev, current) => 
              (prev.idSucursal < current.idSucursal) ? prev : current
            ).idSucursal
          : null);
    }
  };

  handleOnDataChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "documento" && value !== "") {
      var letterNumber = /^[0-9a-zA-Z]+$/;
      if (value.length > 9 || !value.match(letterNumber)) {
        return;
      }
    }

    let form = { ...this.state.form };

    form[name] = value;

    this.setState({ form: form });
  };

  handleOnDataChangeMercadoPago = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "numerodocumento" && value !== "") {
      var letterNumber = /^[0-9a-zA-Z]+$/;
      if (value.length > 9 || !value.match(letterNumber)) {
        return;
      }
    }

    if (name === "informacionTarjeta") {
      value = value.replace(/ /g, "");
    }

    let formMercadoPago = { ...this.state.formMercadoPago };

    formMercadoPago[name] = value;

    this.setState({ formMercadoPago: formMercadoPago }, () => {
      if (name === "informacionTarjeta") {
        if (value.length >= 6) {
          let bin = value.substring(0, 6);
          window.Mercadopago.getPaymentMethod(
            {
              bin: bin,
            },
            this.setPaymentMethod
          );
        }
      }
    });
  };

  setPaymentMethod = (status, response) => {
    if (status === 200 && response.length > 0) {
      let paymentMethodId = response[0].id;
      let paymentTypeId = response[0].payment_type_id;

      /*if(response[0].payment_type_id === "debit_card"){
        
        let form = this.state.formMercadoPago
        form.cuotastarjeta = '1'
        form.installments = [{value:'',text:''}]

        this.setState({formMercadoPago: form}, () => 
          Notification.showError(`Operación válida solo con tarjetas de crédito.`)
        )
        
        return
      }*/

      let form = { ...this.state.formMercadoPago };

      form.paimenttypeid = paymentTypeId;

      form.paimentmethodid = paymentMethodId;

      this.setState({ formMercadoPago: form }, this.getInstallments);

      // let element = document.getElementById('payment_method_id');
      // element.value = paymentMethodId;
      //this.getInstallments();
    } else {
      let form = this.state.formMercadoPago;
      form.cuotastarjeta = "1";
      form.installments = [{ value: "", text: "" }];
      this.setState({ formMercadoPago: form });
    }
  };

  getInstallments = () => {
    var component = this;
    let form = { ...this.state.formMercadoPago };
    window.Mercadopago.getInstallments(
      {
        bin: form.informacionTarjeta.substring(0, 6),

        payment_method_id: form.paimentmethodid,

        amount: parseFloat(this.props.dataPedido.pedido.precioFinal),
      },
      function(status, response) {
        if (status === 200) {
          form.installments = [];

          //document.getElementById('installments').options.length = 0;
          response[0].payer_costs.forEach((installment) => {
            //console.log(installment);

            //var installmentObj=new installment();
            // installmentObj.
            let objectInstallment = {
              value: installment.installments,
              text: installment.recommended_message,
            };

            form.installments.push(objectInstallment);
            //form.installmentDescriptions.push(installment.recommended_message);
            /*let opt = document.createElement('option');
              opt.text = installment.recommended_message;
              opt.value = installment.installments;
              document.getElementById('installments').appendChild(opt);*/
          });

          component.setState({ formMercadoPago: form });
        } else {
          let form = this.state.formMercadoPago;
          form.cuotastarjeta = "1";
          form.installments = [{ value: "", text: "" }];
          this.setState({ formMercadoPago: form });
        }
      }
    );
  };

  handleOnSaveDatosAdicionales = () => {
    let valida = true;
    let errores = {};

    // valido el documento
    if (
      this.state.form.documento === undefined ||
      this.state.form.documento === "" ||
      this.state.form.documento.length < 7
    ) {
      errores.documento = "Ingrese un Nro. de documento correcto";
      valida = false;
    }

    // valido el teléfono
    if (
      this.state.form.telefono === undefined ||
      this.state.form.telefono === "" ||
      this.state.form.telefono.includes("_") ||
      this.state.form.telefono.includes(".")
    ) {
      errores.telefono = "Ingrese un teléfono correcto";
      valida = false;
    }

    if (!valida) {
      this.setState({ errores: errores });
      return;
    }

    this.setState({ errores: {} }, () => {
      let payload = {
        dni: this.state.form.documento.trim(),
        telefono: this.state.form.telefono.trim(),
        idUsuario: this.props.usuario.id,
      };

      payload.callback = () => {
        Notification.showSuccess(`Datos guardados con éxito`);
        this.setState({ openModal: false });
      };

      payload.callbackError = () => {
        Notification.showError(`Error al guardar los datos`);
      };

      this.props.sagaSaveDatosAdicionales(payload);
    });
  };

  sdkResponseHandler = (status, response) => {
    if (status !== 200 && status !== 201) {
      if (response.cause && response.cause.length > 0) {
        let code = response.cause[0].code;
        let errores = { ...this.props.errores };
        let mensaje = "";

        switch (code) {
          case "205": {
            mensaje = "Ingresa el número de tu tarjeta.";
            errores.informacionTarjeta = mensaje;
            break;
          }
          case "208": {
            mensaje = "Elige un mes.";
            errores.fechavencimiento = mensaje;
            break;
          }
          case "209": {
            mensaje = "Elige un año.";
            errores.fechavencimiento = mensaje;
            break;
          }
          case "212": {
            mensaje = "Ingresa tu tipo de documento.";
            //errores.fechavencimiento = mensaje
            break;
          }
          case "213": {
            mensaje = "Ingresa tu documento.";
            errores.numerodocumento = mensaje;
            break;
          }
          case "214": {
            mensaje = "Ingresa tu documento.";
            errores.numerodocumento = mensaje;
            break;
          }
          case "220": {
            mensaje = "Ingresa tu banco.";
            break;
          }
          case "221": {
            mensaje = "Ingresa el nombre y apellido.";
            errores.nombreEnTarjeta = mensaje;
            break;
          }
          case "224": {
            mensaje = "Ingresa el código de seguridad.";
            errores.codigoverificacion = mensaje;
            break;
          }
          case "E301": {
            mensaje = "Ingresa un número de tarjeta válido.";
            errores.informacionTarjeta = mensaje;
            break;
          }
          case "E302": {
            mensaje = "Revisa el código de seguridad.";
            errores.codigoverificacion = mensaje;
            break;
          }
          case "316": {
            mensaje = "Ingresa un nombre válido.";
            errores.nombreEnTarjeta = mensaje;
            break;
          }
          case "322": {
            mensaje = "El tipo de documento es inválido.";
            //errores.numerodocumento = mensaje
            break;
          }
          case "323": {
            mensaje = "Revisa tu documento.";
            errores.numerodocumento = mensaje;
            break;
          }
          case "324": {
            mensaje = "El documento es inválido.";
            errores.numerodocumento = mensaje;
            break;
          }
          case "325": {
            mensaje = "Revise la fecha ingresada";
            errores.fechavencimiento = mensaje;
            break;
          }
          case "326": {
            mensaje = "Revise la fecha ingresada";
            errores.fechavencimiento = mensaje;
            break;
          }
          default: {
            mensaje = "Revisa los datos";
            break;
          }
        }
        this.setState({ errores: errores, disabledPagar: false }, () => {
          Notification.showError(mensaje);
        });
      } else {
        this.setState({ disabledPagar: false }, () => {
          Notification.showError("Revisa los datos ingresados por favor");
        });
      }
    } else {
      this.setState({ errores: {} }, () => {
        let payload = {
          IdInstalacion: this.props.instalacion.id,
          IdPedido: this.props.dataPedido.pedido.id,
          Total: this.props.dataPedido.pedido.precioFinal,
          Token: response.id,
          Cuotas: this.state.formMercadoPago.cuotastarjeta,
          PayMentMethod: this.state.formMercadoPago.paimentmethodid,
          PayMentMethodType: this.state.formMercadoPago.paimenttypeid,
          email: this.state.formMercadoPago.emailMercadoPago,
          idCalendarioHorario: this.state.horaSeleccionada.idHorario,
          fechaTurno: this.state.fechaSeleccionada.fecha,
          dni: this.state.formMercadoPago.numerodocumento,
          tipoDocumento: this.state.formMercadoPago.tipodocumento,
          tipoEntrega: this.state.entregaElegida
            ? this.state.entregaElegida
            : 0,
          IdEstadoPedido: estadosPedido.CONFIRMADO,
          IdFormaPagoOnline: formaPagoOnline.MercadoPago,
          IdFormaEntrega: this.state.entregaElegida
            ? this.state.entregaElegida
            : 0,
          Domicilio: this.state.domicilioSeleccionadoItem
            ? this.state.domicilioSeleccionadoItem.domicilio +
              (this.state.domicilioSeleccionadoItem.pisoDepto
                ? " (" +
                  this.state.domicilioSeleccionadoItem.pisoDepto +
                  (this.state.domicilioSeleccionadoItem.opcional ? "" : ")")
                : "") +
              (this.state.domicilioSeleccionadoItem.opcional
                ? (this.state.domicilioSeleccionadoItem.pisoDepto
                    ? " "
                    : " (") +
                  this.state.domicilioSeleccionadoItem.opcional +
                  ")"
                : "")
            : "",
          FaltaGeoreferenciar:
            this.state.domicilioSeleccionadoItem &&
            this.state.domicilioSeleccionadoItem.faltaGeorreferenciar === true
              ? true
              : undefined,
          IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
            ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
            : undefined,
        };

        payload.callback = (estado) => {
          if (estado.exitoso) {
            this.setState(
              { openModalCompraExitosa: true, disabledPagar: false },
              () => {
                Notification.showSuccess(estado.estado);
                window.Mercadopago.clearSession();
              }
            );

            // actualizo el estado del pedido
            let payload = {
              Id: this.props.dataPedido.pedido.id,
              IdEstadoPedido: estadosPedido.CONFIRMADO,
              IdFormaPagoOnline: formaPagoOnline.MercadoPago,
              IdCalendarioHorario: this.state.horaSeleccionada.idHorario,
              FechaTurno: this.state.fechaSeleccionada.fecha,
              IdFormaEntrega: this.state.entregaElegida
                ? this.state.entregaElegida
                : 0,
              Domicilio: this.state.domicilioSeleccionadoItem
                ? this.state.domicilioSeleccionadoItem.domicilio +
                  (this.state.domicilioSeleccionadoItem.pisoDepto
                    ? " (" +
                      this.state.domicilioSeleccionadoItem.pisoDepto +
                      (this.state.domicilioSeleccionadoItem.opcional ? "" : ")")
                    : "") +
                  (this.state.domicilioSeleccionadoItem.opcional
                    ? (this.state.domicilioSeleccionadoItem.pisoDepto
                        ? " "
                        : " (") +
                      this.state.domicilioSeleccionadoItem.opcional +
                      ")"
                    : "")
                : "",
              IdInstalacion: this.props.instalacion
                ? this.props.instalacion.id
                : 0,
            };

            /*payload.callback = () => {
                this.setState({openModalCompraExitosa: true})
                window.Mercadopago.clearSession();
              }*/

            this.props.sagaEnviarMailConfirmacion(payload);
          }
        };

        payload.callbackError = (event) => {
          this.setState({ disabledPagar: false });
          window.Mercadopago.clearSession();
        };

        //this.props.sagaSaveDatosAdicionales(payload)
        this.props.setPedidoPagoMP(payload);
      });
    }
  };

  handleOnPagar = () => {
    if (this.state.disabledPagar === true) {
      return;
    }

    this.setState({ disabledPagar: true });

    let valida = true;
    let errores = {};
    // valido el nombre en la tarjeta
    if (
      this.state.formMercadoPago.nombreEnTarjeta === undefined ||
      this.state.formMercadoPago.nombreEnTarjeta === ""
    ) {
      errores.nombreEnTarjeta = "Ingrese el nombre en la tarjeta";
      valida = false;
    }

    // valido el número de tarjeta
    if (
      this.state.formMercadoPago.informacionTarjeta === undefined ||
      this.state.formMercadoPago.informacionTarjeta === ""
    ) {
      errores.informacionTarjeta = "Ingrese el número de tarjeta";
      valida = false;
    }

    // valido el vencimiento de la tarjeta
    if (
      this.state.formMercadoPago.fechavencimiento === undefined ||
      this.state.formMercadoPago.fechavencimiento === ""
    ) {
      errores.fechavencimiento = "Ingrese la fecha de vencimiento";
      valida = false;
    }

    // valido el cod de verificación de la tarjeta
    if (
      this.state.formMercadoPago.codigoverificacion === undefined ||
      this.state.formMercadoPago.codigoverificacion === ""
    ) {
      errores.codigoverificacion = "Ingrese el código de seguridad";
      valida = false;
    }

    // valido el nro de documento
    if (
      this.state.formMercadoPago.numerodocumento === undefined ||
      this.state.formMercadoPago.numerodocumento === ""
    ) {
      errores.numerodocumento = "Ingrese el número de documento";
      valida = false;
    }
    // valido el email
    if (
      this.state.formMercadoPago.emailMercadoPago === undefined ||
      this.state.formMercadoPago.emailMercadoPago === ""
    ) {
      errores.emailMercadoPago = "Ingrese el e-mail";
      valida = false;
    }

    if (!valida) {
      this.setState({
        /*showMetodosPago: undefined,*/ errores: errores,
        disabledPagar: false,
      });
      return;
    }

    let data = this.state.formMercadoPago;

    if (data != null) {
      window.Mercadopago.createToken(
        {
          cardNumber: data.informacionTarjeta.trim(),
          securityCode: data.codigoverificacion,
          cardExpirationMonth: data.fechavencimiento.split("/")[0],
          cardExpirationYear: data.fechavencimiento.split("/")[1],
          cardholderName: data.nombreEnTarjeta,
          docType: data.tipodocumento,
          docNumber: data.numerodocumento,
          installments: data.cuotastarjeta,
        },
        this.sdkResponseHandler
      );
      //window.Mercadopago.createToken($form, sdkResponseHandler);
    }
  };

  handleChangeRadioButton = (event) => {
    let select = event.target.value;
    let value = select;

    if (value === "1") {
      value = true;
    } else {
      value = false;
    }

    let payload = {
      value: value,
      idPedidoDetalle: undefined,
      idPedido:
        this.props.dataPedido && this.props.dataPedido.pedido
          ? this.props.dataPedido.pedido.id
          : 0,
      pedidoCompleto: true,
    };

    payload.callback = () => {
      this.setState({ reemplazarProductos: select });
    };

    this.props.sagaSetPedidoDetalleReemplazo(payload);
  };

  handleChangeRadioButtonIndividual = (event, idPedidoDetalle) => {
    let value = event.target.value;

    if (value === "false") {
      value = false;
    } else {
      value = true;
    }

    if (!idPedidoDetalle) {
      return;
    }

    let payload = {
      value: value,
      idPedidoDetalle: idPedidoDetalle,
      idPedido: 0,
      pedidoCompleto: false,
    };

    payload.callback = () => {
      this.checkPermisosReemplazo();
    };

    this.props.sagaSetPedidoDetalleReemplazo(payload);
  };

  handleOnClickBtnFormaPago = (value) => {
    this.setState({ showMetodosPago: value }, () => {
      console.log("showMetodosPago", value);
      // if (value === 1) {
      //   this.renderMobbexButton();
      // }

      if (value === 5) {
        console.log('pedido antes', this.props.dataPedido.pedido);
        this.handleOnClickActualizarDataPedido(estadosPedido.BORRADOR);
        //get pedido this.handleOnClickActualizarDataPedido(estadosPedido.BORRADOR);
        this.openCustomDialog();
      }
    });
  };


handleRenderBtnFormaPago = (value) => {
  this.setState({ showMetodosPago: value }, () => {
    if (value === 5) {
      console.log('pedido antes', this.props.dataPedido.pedido);
      this.setState({
        pedidoId: this.props.dataPedido.pedido.id,
        pedidoPrecioFinal: this.props.dataPedido.pedido.precioFinal
      }, () => {
        this.openCustomDialog();
      });
    }
  });
};


  componentDidMount = async () => {
    loadStencilComponents(url_payment_gateway);
    const hash = window.location.hash;
    const urlParams = new URLSearchParams(hash.split("?")[1]);
    let externalid = urlParams.get("external_reference");
    const result = urlParams.get("result");
    console.log('result',result)

    // Extraer solo la parte numérica si viene con prefijo DEFAULT-  del tenant
    if (externalid && externalid.startsWith("DEFAULT-")) {
    externalid = externalid.replace("DEFAULT-", "");
  }

    // Si no está en el hash, buscar en la URL principal
    if (!externalid) {
      const searchParams = new URLSearchParams(window.location.search);
      externalid = searchParams.get("external_id");
    }


    if (result === "fail") {
      console.log("Error en la compra - result=fail");
      this.setState({ openModalCompraNoExitosa: true }, () => {
      Notification.showInfo("Pago no procesado");
      });
      return;
    }

    if (externalid) {
      const pedido = await getPedidoById(externalid);
      this.setState({ pedidoActual: pedido });
      this.setState({ pedidoId: externalid });
      // iniciar el polling
      this.startPolling(externalid);
    } else {
      // Si no se obtuvo externalid, asigna valores desde dataPedido
      const { dataPedido } = this.props;
      if (dataPedido && dataPedido.pedido) {
        this.setState({ pedidoId: dataPedido.pedido.id, pedidoPrecioFinal: dataPedido.pedido.precioFinal });
      }
    }
        try {
          const localidades = await GetLocalidadesEntregaActivas();
          this.setState({
            localidadesEntregaActivas: localidades,
            localidadesCargadas: true
          });
        } catch (error) {
          this.setState({ 
            mensaje: 'Error al cargar las localidades',
            localidadesCargadas: false
          });
        }
        this.setState({ isDataLoaded: true });
  };


  componentWillUnmount = () => {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      console.log("Polling interval limpiado en componentWillUnmount");
    }
    if (this.timeoutPolling) { 
      console.log('componentWillUnmount - timeExceeded:', this.state.timeExceeded);
      clearTimeout(this.timeoutPolling); 
      console.log("Timeout limpiado en componentWillUnmount");
    }
  };

  startPolling = (externalId) => {
    // No iniciar polling si ya está activo
    if (this.state.pollingActive) return;
    console.log("startPolling: Activando polling para externalId:", externalId);
    this.setState({ pollingActive: true, timeExceeded: false }, () => {
      console.log("startPolling - Estado actualizado:", this.state);
    });
    // Ejecuta inmediatamente la primera consulta y luego cada 5 segundos
    this.checkOrderStatus(externalId);
    this.pollingInterval = setInterval(() => {
      console.log("Polling interval tick");
      this.checkOrderStatus(externalId);
    }, 5000);

    this.timeoutPolling = setTimeout(() => {
      console.log("Timeout reached: 10 seconds passed");
      clearInterval(this.pollingInterval);
      this.setState({ 
        pollingActive: false, 
        timeExceeded: true, 
        openModalPagoPendiente: true
      }, async () => {
        console.log("startPolling - Timeout callback, estado actualizado:", this.state);
        //Modificar el pedido a estado Pendiente para no mostrar en el carrito
        const pedido = await updateEstadoPedidoById(externalId, estadosPedido.PENDIENTE);
        console.log('pedido cuando reinicia', pedido);
        
      });
    }, 30000);
  };

  checkOrderStatus = async (externalId) => {
    try {
      // Consultar el estado del pedido,
      const estadoPedido = await getStatusPedidoById(externalId);
      console.log("checkOrderStatus - estadoPedido api:", estadoPedido);
      // Actualizar estado del componente con la descripción del estado
      this.setState({ pedidoStatus: estadoPedido.pedidoPagado }, () => {
        console.log("checkOrderStatus - pedidoStatus actualizado:", this.state.pedidoStatus);
      });
      
      if (estadoPedido.pedidoPagado === true) {
        console.log("checkOrderStatus: Pago confirmado, deteniendo polling");
        clearInterval(this.pollingInterval);
        clearTimeout(this.timeoutPolling);
        this.setState({ pollingActive: false,
           openModalCompraExitosa: true,
            openModalPagoPendiente: false }, () => {
              console.log("checkOrderStatus - Estado actualizado tras confirmación:", this.state);
            });
      }
      else{
        this.setState({ openModalPagoPendiente: true });
      }
    } catch (error) {
      console.error("Error al consultar el estado del pedido:", error);
    }
  };

  checkPaymentResult = () => {
    console.log("este es el precio final", this.props.pedidoPrecioFinal);
    const urlParams = new URLSearchParams(window.location.search);
    const result = urlParams.get("result");
  
    if (result === "success") {
      this.showSuccessPopup();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////

  showSuccessPopup = () => {
    console.log("ya se pago");
    this.setState({ openModalCompraExitosa: true }, () => {
      this.setState({ reemplazarProductos: "1" });
      Notification.showSuccess("Pago procesado con éxito");
    });
    Notification.showSuccess("Pago procesado con éxito");

    let payloadConfirmar = {
      Id: this.props.dataPedido.pedido.id,
      IdEstadoPedido: estadosPedido.CONFIRMADO,
      // IdFormaPagoOnline: formaPagoOnline.Mobbex,
      IdFormaEntrega: this.state.entregaElegida ? this.state.entregaElegida : 0,
      IdCalendarioHorario: this.state.horaSeleccionada.idHorario,
      FechaTurno: this.state.fechaSeleccionada.fecha,
      Domicilio: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.domicilio +
          (this.state.domicilioSeleccionadoItem.pisoDepto
            ? " (" +
              this.state.domicilioSeleccionadoItem.pisoDepto +
              (this.state.domicilioSeleccionadoItem.opcional ? "" : ")")
            : "") +
          (this.state.domicilioSeleccionadoItem.opcional
            ? (this.state.domicilioSeleccionadoItem.pisoDepto ? " " : " (") +
              this.state.domicilioSeleccionadoItem.opcional +
              ")"
            : "")
        : "",
      IdInstalacion: this.props.instalacion.id,
      FaltaGeoreferenciar:
        this.state.domicilioSeleccionadoItem &&
        this.state.domicilioSeleccionadoItem.faltaGeorreferenciar === true
          ? true
          : undefined,
      IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
        : undefined,
      IdTipoFacturacion: this.state.tipoFacturacion,
      IdClienteDatosFacturacion: this.state.idClienteDatosFacturacion,
      IdCheckout: "1",
      IdPago: "2",
      Code: "200",
      Status: "success",
      EnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        this.props.dataPedido.pedido.precioFinal >
          this.props.instalacion.montoDeliveryBonificado
          ? true
          : false,
      MontoEnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        this.props.dataPedido.pedido.precioFinal >
          this.props.instalacion.montoDeliveryBonificado
          ? this.props.instalacion.montoDeliveryBonificado
          : 0,
      idSucursal:
        this.state.entregaElegida == 2
          ? this.getSucursalDefecto(this.state.entregaElegida)
          : this.state.sucursalPickupSeleccionada,
    };

    payloadConfirmar.callback = () => {
      this.setState(
        { openModalCompraExitosa: true, showMetodosPago: undefined },
        () => {
          Notification.showSuccess("Pago procesado con éxito");
        }
      );
    };
    setTimeout(() => {
      this.props.sagaConfirmarPedidoMobbex(payloadConfirmar);
    }, 1000);
  };

  openCustomDialog = () => {
    this.setState({ openCustomDialog: true });
  };

  handleCloseCustomDialog = () => {
    document.body.style.overflow = "auto";
    this.setState({ openCustomDialog: false });
  };

  handlePaymentSuccess = (data, precioFinal) => {
    // debugger;
    //data es el external id, que es el id del pedido
    // if (data && data.data && data.data.status && (data.data.status.code === "200" || data.data.status.code === "3")) {

    let payloadConfirmar = {
      Id: parseInt(data, 10),
      IdEstadoPedido: estadosPedido.CONFIRMADO,
      IdFormaPagoOnline: 3,
      IdFormaEntrega: this.state.entregaElegida ? this.state.entregaElegida : 0,
      // IdCalendarioHorario: this.state.horaSeleccionada.idHorario,
      //  FechaTurno: this.state.fechaSeleccionada.fecha,
      Domicilio: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.domicilio +
          (this.state.domicilioSeleccionadoItem.pisoDepto
            ? " (" +
              this.state.domicilioSeleccionadoItem.pisoDepto +
              (this.state.domicilioSeleccionadoItem.opcional ? "" : ")")
            : "") +
          (this.state.domicilioSeleccionadoItem.opcional
            ? (this.state.domicilioSeleccionadoItem.pisoDepto ? " " : " (") +
              this.state.domicilioSeleccionadoItem.opcional +
              ")"
            : "")
        : "",
      IdInstalacion: this.props.instalacion.id,
      FaltaGeoreferenciar:
        this.state.domicilioSeleccionadoItem &&
        this.state.domicilioSeleccionadoItem.faltaGeorreferenciar === true
          ? true
          : undefined,
      IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
        : undefined,
      IdTipoFacturacion: this.state.tipoFacturacion,
      IdClienteDatosFacturacion: this.state.idClienteDatosFacturacion,
      IdCheckout: "CHK:PT5R9NTLSSLYRLYP2M",
      // IdPago: data.data.id,
      // Code: data.data.status.code,
      Status: "success",
      EnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        precioFinal > this.props.instalacion.montoDeliveryBonificado
          ? true
          : false,
      MontoEnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        precioFinal > this.props.instalacion.montoDeliveryBonificado
          ? this.props.instalacion.montoDeliveryBonificado
          : 0,
      idSucursal:
        this.state.entregaElegida == 2
          ? this.getSucursalDefecto(this.state.entregaElegida)
          : this.state.sucursalPickupSeleccionada,

            callback: (response) => {
              console.log('Callback ejecutado con data:', response);
              if (response.Status === "success") {
                this.setState({ openModalCompraExitosa: true }, () => {
                  Notification.showSuccess("Pago procesado con éxito");
                });
              } else {
                this.setState({ openModalCompraNoExitosa: true }, () => {
                  Notification.showInfo("Pago no procesado");
                });
              }
            }
          };
      
        console.log('entro a handlePaymentSuccess 200', payloadConfirmar);
      
        setTimeout(() => {
          if (payloadConfirmar.Status === 'success') {
            console.log('entro set time out', payloadConfirmar);
            this.props.sagaConfirmarPedidoMobbex(payloadConfirmar);
            payloadConfirmar.callback(payloadConfirmar);
          }
        }, 1000);
  };

  handleOnClickFinalizarCompra = () => {
    if (
      this.props.dataPedido === undefined ||
      this.props.dataPedido.pedido === undefined
    ) {
      return;
    }

    this.setState({ disabledPagar: true });

    let payload = {
      Id: this.props.dataPedido.pedido.id,
      IdEstadoPedido: estadosPedido.CONFIRMADO,
      IdFormaPagoOnline:
        this.state.showMetodosPago === 2
          ? formaPagoOnline.PagoAlRetirar
          : (this.state.showMetodosPago === 4 || this.state.showMetodosPago === 6 || this.state.showMetodosPago === 7)
          ? this.state.showMetodosPago
          : formaPagoOnline.PagoAlRecibir, 
      IdFormaEntrega: this.state.entregaElegida ? this.state.entregaElegida : 0,
      IdCalendarioHorario: this.state.horaSeleccionada.idHorario,
      FechaTurno: this.state.fechaSeleccionada.fecha,
      Domicilio: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.domicilio
        : undefined,
      IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
        : undefined,
      FaltaGeoreferenciar:
        this.state.domicilioSeleccionadoItem &&
        this.state.domicilioSeleccionadoItem.faltaGeorreferenciar === true
          ? true
          : undefined,
      IdInstalacion: this.props.instalacion ? this.props.instalacion.id : 0,
      IdTipoFacturacion: this.state.tipoFacturacion,
      IdClienteDatosFacturacion: this.state.idClienteDatosFacturacion,
      EnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        this.props.dataPedido.pedido.precioFinal >
          this.props.instalacion.montoDeliveryBonificado
          ? true
          : false,
      MontoEnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        this.props.dataPedido.pedido.precioFinal >
          this.props.instalacion.montoDeliveryBonificado
          ? this.props.instalacion.montoDeliveryBonificado
          : 0,
      idSucursal: this.state.sucursalPickupSeleccionada,
    };

    payload.callback = () => {
      this.setState({ openModalCompraExitosa: true, disabledPagar: false });
    };

    this.props.sagaConfirmarEliminarPedido(payload);
  };
  
  
  handleOnClickActualizarDataPedido = (estadoPedido) => {
    if (
      this.props.dataPedido === undefined ||
      this.props.dataPedido.pedido === undefined
    ) {
      return;
    }

    this.setState({ disabledPagar: true });
    let payload = {
      Id: this.props.dataPedido.pedido.id,
      IdEstadoPedido: estadoPedido,
      IdFormaPagoOnline: 5,
      IdFormaEntrega: this.state.entregaElegida ? this.state.entregaElegida : 0,
      IdCalendarioHorario: this.state.horaSeleccionada.idHorario,
      FechaTurno: this.state.fechaSeleccionada.fecha,
      Domicilio: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.domicilio
        : undefined,
      IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
        ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
        : undefined,
      FaltaGeoreferenciar:
        this.state.domicilioSeleccionadoItem &&
        this.state.domicilioSeleccionadoItem.faltaGeorreferenciar === true
          ? true
          : undefined,
      IdInstalacion: this.props.instalacion ? this.props.instalacion.id : 0,
      IdTipoFacturacion: this.state.tipoFacturacion,
      IdClienteDatosFacturacion: this.state.idClienteDatosFacturacion,
      EnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        this.props.dataPedido.pedido.precioFinal >
          this.props.instalacion.montoDeliveryBonificado
          ? true
          : false,
      MontoEnvioBonificado:
        this.props.instalacion.cobroDelivery &&
        this.props.instalacion.deliveryBonificado &&
        this.props.dataPedido.pedido.precioFinal >
          this.props.instalacion.montoDeliveryBonificado
          ? this.props.instalacion.montoDeliveryBonificado
          : 0,
      idSucursal: this.state.sucursalPickupSeleccionada,
    };
    this.props.sagaActualizarDataPedido(payload);
  };

  handleOnClickEntendido = () => {
    this.setState({ openModalCompraExitosa: false, openModalCompraNoExitosa: false, openModalPagoPendiente: false }, () => {
      //limpio el catalogo para evitar que se dupliquen los articulos
      this.props.setBuscandoCatalogo(true);
      this.props.setCatalogoSeleccionado(undefined);

      // Redirigir a la raíz sin parámetros ni hash
      window.location.hash = `/`;
      showModal();
    });
  };

  handleOnClickEntendidoFromCompraFallida = () => {
    this.setState({
      openModalCompraNoExitosa: false,
    }, () => {
      this.handleRenderBtnFormaPago(5);
    })
  }

  handleOnClickBackToCatalogo = () => {
    //this.props.setLimpiarFiltro(true)

    //limpio el catalogo para evitar que se dupliquen los articulos
    this.props.setBuscandoCatalogo(true);
    this.props.setCatalogoSeleccionado(undefined);

    window.location.hash = `/Catalogo`;
  };

  handleOnChangeSucursalPickup = (idSucursal) => {
    if (!idSucursal) {
      return;
    }

    this.setState({
      sucursalPickupSeleccionada: idSucursal,
      fechaSeleccionada: undefined,
      horaSeleccionada: undefined,
      permitePago: false,
    });

    const payload = {
      idTipoCalendario: 1,
      idInstalacion: idSucursal,
      idRecurso: idSucursal,
    };

    this.props.sagaFetchCalendario(payload);
  };

  obtenerDomicilioLocalidadPreferenciaCliente = async (idCliente ) => {
  try {
    const response = await getDomicilioLocalidadPreferenciaEntregaCliente(idCliente);
      if (response!=null) {
        this.setState({
          domicilioSeleccionado:response.idDomicilioEntrega,
          domicilioSeleccionadoItem:response,
        });
      }
  } catch (error) {
    console.error("Error:", error);
  }
};


  handleOnClickBtnEntrega = async (value) => {
    if (this.props.usuario && this.props.usuario.idCliente) {
    try {
      await this.obtenerDomicilioLocalidadPreferenciaCliente(this.props.usuario.idCliente);
    } catch (error) {
      console.error("Error al verificar localidad:", error);
    }
  }
    if (preferenciaEntrega.Delivery === value) {
      let domicilioSeleccionadoItem = this.state.domicilioSeleccionado; 
    if (this.state.domicilioSeleccionado) {
      // Buscar el domicilio completo por ID
      domicilioSeleccionadoItem = this.props.usuario.domiciliosEntrega.find(
        d => d.idDomicilioEntrega.toString() === this.state.domicilioSeleccionado.toString()
      );
    }
    
    // Si no hay domicilio seleccionado, intentar obtener el primero o el último usado
    if (!domicilioSeleccionadoItem && this.props.usuario.domiciliosEntrega && this.props.usuario.domiciliosEntrega.length > 0) {
      
      domicilioSeleccionadoItem = this.state.ultimoDomicilioEntrega
        ? this.props.usuario.domiciliosEntrega.find(
            x => x.idDomicilioEntrega === this.state.idUltimoDomicilioEntrega
          )
        : this.props.usuario.domiciliosEntrega[0];
    }

    // Verificar si el domicilio existe y no tiene localidad
    if (domicilioSeleccionadoItem && domicilioSeleccionadoItem.idLocalidadEntrega === null) {
      this.setState({
        openModalSolicitudLocalidadEntrega: true,
        domicilioPreferenciaCliente: domicilioSeleccionadoItem,
      });

      return; // Salir sin llamar al calendario
    } 

      let payload = {};
      payload.idTipoCalendario = value;
      payload.idInstalacion = this.getSucursalDefecto(2);
      payload.idRecurso = this.getSucursalDefecto(2) || 1;
      payload.idCliente = this.props.usuario.idCliente;
      payload.idDomicilioEntrega = this.state.domicilioSeleccionado
        ? this.state.domicilioSeleccionado
        : null;
      payload.callBack = () => {
        let domicilioSeleccionado = undefined;
        let domicilioSeleccionadoItem = undefined;
        let showTurnero = false;

        if (
          this.props.usuario.domiciliosEntrega !== undefined &&
          this.props.usuario.domiciliosEntrega.length > 0
        ) {
          if (!this.state.domicilioSeleccionadoItem) {
            domicilioSeleccionado = this.state.ultimoDomicilioEntrega
              ? this.state.idUltimoDomicilioEntrega
              : this.props.usuario.domiciliosEntrega[0].idDomicilioEntrega;
            domicilioSeleccionadoItem = this.state.ultimoDomicilioEntrega
              ? this.props.usuario.domiciliosEntrega.find(
                  (x) =>
                    x.idDomicilioEntrega === this.state.idUltimoDomicilioEntrega
                )
              : this.props.usuario.domiciliosEntrega[0];
          } else {
            domicilioSeleccionado = this.state.domicilioSeleccionado;
            domicilioSeleccionadoItem = this.state.domicilioSeleccionadoItem;
          }

          showTurnero = true;
        }

        this.setState({
          preferenciaEntregaElegida: true,
          entregaElegida: value,
          domicilioSeleccionado: domicilioSeleccionado,
          domicilioSeleccionadoItem: domicilioSeleccionadoItem,
          showTurnero: showTurnero,
          sucursalPickupSeleccionada: this.getSucursalDefecto(2),
        });
      };

      //busco el calendario
      this.props.sagaFetchCalendario(payload);
    } else {
      this.setState({
        preferenciaEntregaElegida: true,
        entregaElegida: value,
        showTurnero: true,
        sucursalPickupSeleccionada: undefined,
        fechaSeleccionada: undefined,
        horaSeleccionada: undefined,
        permitePago: false,
      });
    }
  };

  handleOnClickCambiarPreferencia = () => {
    this.setState({
      preferenciaEntregaElegida: false,
      entregaElegida: undefined,
      permitePago: false,
      fechaSeleccionada: undefined,
      horaSeleccionada: undefined,
      showTurnero: false,
      showMetodosPago: undefined,
    });
  };

  handleOnClickDia = (itemDia) => {
    this.setState({ fechaSeleccionada: itemDia });
  };

  handleOnClickHorario = (itemHorario) => {
    this.setState(
      { horaSeleccionada: itemHorario, permitePago: true },
      () => {}
    );
  };
  handleOnClickPreferenciaFacturacion = (value) => {
    this.setState(
      { preferenciaFacturacionElegida: false, showMetodoFacturacion: value },
      () => {}
    );
  };

  handleOnClickCambiarFechaHora = () => {
    this.setState({
      fechaSeleccionada: undefined,
      horaSeleccionada: undefined,
      permitePago: false,
    });
  };

  handleOnChangeFacturacion = (tipoFacturacion, idClienteDatosFacturacion) => {
    this.setState({ tipoFacturacion, idClienteDatosFacturacion });
  };

handleOnClickCambiarDomicilio = (value) => {
  this.props.sagaFetchUsuarioLogeado()
  const previousState = {
    domicilioSeleccionado: this.state.domicilioSeleccionado,
    domicilioSeleccionadoItem: this.state.domicilioSeleccionadoItem,
    showTurnero: this.state.showTurnero,
    select: this.state.domicilioSeleccionado,
    item: this.state.domicilioSeleccionadoItem
  };

  this.setState({
    previousDomicilioState: previousState,
    domicilioSeleccionado: undefined,
    showTurnero: false,
    horaSeleccionada: undefined,
    permitePago: false,
  });
};

  handleChangeRadioButtonDomicilio = (event) => {
    let select = event; //event.target.value
    let item = undefined;

    if (
      this.props.usuario === undefined ||
      this.props.usuario.domiciliosEntrega === undefined ||
      this.props.usuario.domiciliosEntrega.length === 0
    ) {
      return;
    }

    this.props.usuario.domiciliosEntrega.forEach((d) => {
      if (d.idDomicilioEntrega.toString() === select) {
        item = d;
      }
    });

if (item && item.idLocalidadEntrega === null) {
    this.setState({
      openModalSolicitudLocalidadEntrega: true,
      domicilioPreferenciaCliente: item,
      pendingDomicilioAction: { select, item }
    });
    return;
  }


  this.setState({
    domicilioSeleccionado: select,
    domicilioSeleccionadoItem: item
  }, () => {
    this.procesarSeleccionDomicilio(select, item);
  });
};

procesarSeleccionDomicilio = (select, item) => {

  const payload = {
    idTipoCalendario: 2,
    idInstalacion: this.getSucursalDefecto(2),
    idRecurso: this.getSucursalDefecto(2) || 1,
    idCliente: this.props.usuario.idCliente,
    idDomicilioEntrega: select ? parseInt(select, 10) : null,
    callBack: () => {
      this.setState({
        preferenciaEntregaElegida: true,
        entregaElegida: 2,
        domicilioSeleccionado: select,
        domicilioSeleccionadoItem: item,
        showTurnero: true,
      });
    }
  };

  this.props.sagaFetchCalendario(payload);
};


handleCloseModal = (options = { byUser: true }) => {

  if (!options.byUser) {
    this.setState({
      openModalSolicitudLocalidadEntrega: false,
      previousDomicilioState: null,
      pendingDomicilioAction: null
    });
    return;
  }
  const { previousDomicilioState } = this.state;

  if (previousDomicilioState) {
    this.setState({
      openModalSolicitudLocalidadEntrega: false,
      ...previousDomicilioState,
      previousDomicilioState: null,
      pendingDomicilioAction: null,
      restorePreviousSelection: true
    }, () => {
    });
  } else {
    this.setState({ 
      openModalSolicitudLocalidadEntrega: false,
      pendingDomicilioAction: null 
    }, () => {
    });
  }
};

  handleAfterSaveNuevoDomicilio = (idDomicilio) => {
    if (
      this.props.usuario === undefined ||
      this.props.usuario.domiciliosEntrega === undefined ||
      this.props.usuario.domiciliosEntrega.length === 0
    ) {
      return;
    }

    let item = undefined;
    let select = idDomicilio.toString();

    this.props.usuario.domiciliosEntrega.forEach((de) => {
      if (de.idDomicilioEntrega === idDomicilio) {
        item = de;
      }
    });

    this.procesarSeleccionDomicilio(select, item);
    // this.setState({
    //   domicilioSeleccionado: select,
    //   domicilioSeleccionadoItem: item,
    //   showTurnero: true,
    // });
  };

  // renderMobbexButton = () => {
  //   if (this.state.disabledPagar === true) {
  //     return;
  //   }

  //   this.setState({ disabledPagar: true });

  //   let payload = {
  //     IdInstalacion: this.props.instalacion.id,
  //     IdPedido: this.props.dataPedido.pedido.id,
  //     Total: this.props.dataPedido.pedido.precioFinal,
  //     idCalendarioHorario: this.state.horaSeleccionada.idHorario,
  //     fechaTurno: this.state.fechaSeleccionada.fecha,
  //     tipoEntrega: this.state.entregaElegida ? this.state.entregaElegida : 0,
  //     IdEstadoPedido: estadosPedido.CONFIRMADO,
  //     IdFormaPagoOnline: formaPagoOnline.Mobbex,
  //     IdFormaEntrega: this.state.entregaElegida ? this.state.entregaElegida : 0,
  //     Domicilio: this.state.domicilioSeleccionadoItem
  //       ? this.state.domicilioSeleccionadoItem.domicilio +
  //         (this.state.domicilioSeleccionadoItem.pisoDepto
  //           ? " (" +
  //             this.state.domicilioSeleccionadoItem.pisoDepto +
  //             (this.state.domicilioSeleccionadoItem.opcional ? "" : ")")
  //           : "") +
  //         (this.state.domicilioSeleccionadoItem.opcional
  //           ? (this.state.domicilioSeleccionadoItem.pisoDepto ? " " : " (") +
  //             this.state.domicilioSeleccionadoItem.opcional +
  //             ")"
  //           : "")
  //       : "",
  //     FaltaGeoreferenciar:
  //       this.state.domicilioSeleccionadoItem &&
  //       this.state.domicilioSeleccionadoItem.faltaGeorreferenciar === true
  //         ? true
  //         : undefined,
  //     IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
  //       ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
  //       : undefined,
  //   };

  //   payload.callback = (response) => {
  //     if (response.exitoso) {
  //       this.setState({ disabledPagar: false }, () => {
  //         if (!response.idCheckout) {
  //           this.setState({ openModalCompraExitosa: true }, () => {
  //             Notification.showSuccess(response.estado);
  //           });
  //           return;
  //         }

  //         var options = {
  //           id: response.idCheckout,
  //           intent: "checkout",
  //           type: "checkout",
  //           onResult: (data) => {
  //             // OnResult es llamado cuando se toca el Botón Cerrar
  //             document.body.style.overflow = "auto";
  //             this.setState({ showMetodosPago: undefined });
  //             window.MobbexEmbed.close();
  //           },
  //           onPayment: (data) => {
  //             if (
  //               data &&
  //               data.data &&
  //               data.data.status &&
  //               (data.data.status.code === "200" ||
  //                 data.data.status.code === "3")
  //             ) {
  //               window.MobbexEmbed.close();

  //               Notification.showSuccess(data.data.status.message);
  //               console.log("onPayment return", data.data);

  //               let payloadConfirmar = {
  //                 Id: this.props.dataPedido.pedido.id,
  //                 IdEstadoPedido: estadosPedido.CONFIRMADO,
  //                 IdFormaPagoOnline: formaPagoOnline.Mobbex,
  //                 IdFormaEntrega: this.state.entregaElegida
  //                   ? this.state.entregaElegida
  //                   : 0,
  //                 IdCalendarioHorario: this.state.horaSeleccionada.idHorario,
  //                 FechaTurno: this.state.fechaSeleccionada.fecha,
  //                 Domicilio: this.state.domicilioSeleccionadoItem
  //                   ? this.state.domicilioSeleccionadoItem.domicilio +
  //                     (this.state.domicilioSeleccionadoItem.pisoDepto
  //                       ? " (" +
  //                         this.state.domicilioSeleccionadoItem.pisoDepto +
  //                         (this.state.domicilioSeleccionadoItem.opcional
  //                           ? ""
  //                           : ")")
  //                       : "") +
  //                     (this.state.domicilioSeleccionadoItem.opcional
  //                       ? (this.state.domicilioSeleccionadoItem.pisoDepto
  //                           ? " "
  //                           : " (") +
  //                         this.state.domicilioSeleccionadoItem.opcional +
  //                         ")"
  //                       : "")
  //                   : "",
  //                 IdInstalacion: this.props.instalacion.id,
  //                 FaltaGeoreferenciar:
  //                   this.state.domicilioSeleccionadoItem &&
  //                   this.state.domicilioSeleccionadoItem
  //                     .faltaGeorreferenciar === true
  //                     ? true
  //                     : undefined,
  //                 IdDomicilioEntrega: this.state.domicilioSeleccionadoItem
  //                   ? this.state.domicilioSeleccionadoItem.idDomicilioEntrega
  //                   : undefined,
  //                 IdTipoFacturacion: this.state.tipoFacturacion,
  //                 IdClienteDatosFacturacion: this.state
  //                   .idClienteDatosFacturacion,
  //                 IdCheckout: response.idCheckout,
  //                 IdPago: data.data.id,
  //                 Code: data.data.status.code,
  //                 Status: data.data.status.text,
  //                 EnvioBonificado:
  //                   this.props.instalacion.cobroDelivery &&
  //                   this.props.instalacion.deliveryBonificado &&
  //                   this.props.dataPedido.pedido.precioFinal >
  //                     this.props.instalacion.montoDeliveryBonificado
  //                     ? true
  //                     : false,
  //                 MontoEnvioBonificado:
  //                   this.props.instalacion.cobroDelivery &&
  //                   this.props.instalacion.deliveryBonificado &&
  //                   this.props.dataPedido.pedido.precioFinal >
  //                     this.props.instalacion.montoDeliveryBonificado
  //                     ? this.props.instalacion.montoDeliveryBonificado
  //                     : 0,
  //                 idSucursal:
  //                   this.state.entregaElegida == 2
  //                     ? this.getSucursalDefecto(this.state.entregaElegida)
  //                     : this.state.sucursalPickupSeleccionada,
  //               };

  //               payloadConfirmar.callback = () => {
  //                 this.setState(
  //                   {
  //                     openModalCompraExitosa: true,
  //                     showMetodosPago: undefined,
  //                   },
  //                   () => {
  //                     Notification.showSuccess("Pago procesado con éxito");
  //                   }
  //                 );
  //               };
  //               setTimeout(() => {
  //                 this.props.sagaConfirmarPedidoMobbex(payloadConfirmar);
  //               }, 1000);
  //             }
  //           },
  //           onOpen: () => {
  //             document.body.style.overflow = "hidden";
  //             console.info("Pago iniciado.");
  //           },
  //           onClose: (cancelled) => {
  //             document.body.style.overflow = "auto";
  //             this.setState({ showMetodosPago: undefined });
  //             console.info(`${cancelled ? "Cancelado" : "Cerrado"}`);
  //           },
  //           onError: (error) => {
  //             document.body.style.overflow = "auto";
  //             this.setState({ showMetodosPago: undefined });
  //             console.error("ERROR: ", error);
  //           },
  //         };

  //         console.log("window.MobbexEmbed", options);
  //         var mbbxButton = window.MobbexEmbed.init(options);

  //         mbbxButton.open();
  //       });
  //     } else {
  //       this.setState({ disabledPagar: false }, () => {
  //         Notification.showError(response.estado);
  //       });
  //     }
  //   };

  //   payload.callbackError = () => {
  //     this.setState({ disabledPagar: false }, () => {
  //       Notification.showError(
  //         "Error al generar checkout, intente nuevamente."
  //       );
  //     });
  //   };

  //   this.props.sagaGenerarCheckoutMobbex(payload);
  // };

  handleOnClickVerMasPedidosDetalle = () => {
    this.setState({ verMasPedidosDetalle: true });
  };
  

  render() {
    const { pedidoId, pedidoPrecioFinal, pedidoStatus } = this.state;
    // console.log("pedidoId props:", this.props.dataPedido.pedido.id);
    // console.log("pedidoId props:", this.props);
    // console.log("pedidoId estado:", pedidoId);

    // console.log("pedidoPrecioFinal props", this.props.dataPedido.pedido.precioFinal);
    // console.log("pedidoPrecioFinal estado", pedidoPrecioFinal);

    return (
      <div>
        <FinalizarCompra
          pedidoStatus={pedidoStatus}
          instalacion={this.props.instalacion}
          pedido={this.props.dataPedido.pedido !== null && this.props.dataPedido.pedido !== undefined 
            ? this.props.dataPedido.pedido 
            : this.state.pedidoActual}
          verMasPedidosDetalle={this.state.verMasPedidosDetalle}
          usuario={this.props.usuario}
          reemplazarProductos={this.state.reemplazarProductos}
          form={this.state.form}
          formMercadoPago={this.state.formMercadoPago}
          errores={this.state.errores}
          showMetodosPago={this.state.showMetodosPago}
          tipodocumento={this.state.formMercadoPago.tipodocumento}
          cuotastarjeta={this.state.formMercadoPago.cuotastarjeta}
          installments={
            this.state.formMercadoPago.installments
              ? this.state.formMercadoPago.installments
              : []
          }
          openModal={this.state.openModal && !this.props.flagDatosAdicionales}
          openModalCompraExitosa={this.state.openModalCompraExitosa}
          openModalPagoPendiente={this.state.openModalPagoPendiente}
          timeExceeded={this.state.timeExceeded}
          openModalCompraNoExitosa={this.state.openModalCompraNoExitosa}
          preferenciaEntregaElegida={this.state.preferenciaEntregaElegida}
          datosFacturacion={{
            tipoFacturacion: this.state.tipoFacturacion,
            idClienteDatosFacturacion: this.state.idClienteDatosFacturacion,
          }}
          handleOnChangeFacturacion={this.handleOnChangeFacturacion}
          entregaElegida={this.state.entregaElegida}
          permitePago={this.state.permitePago}
          fechaHoraSeleccionada={
            this.state.fechaSeleccionada !== undefined &&
            this.state.horaSeleccionada !== undefined
          }
          fechaSeleccionada={this.state.fechaSeleccionada}
          horaSeleccionada={this.state.horaSeleccionada}
          calendario={
            this.props.calendario ? this.props.calendario.calendario : undefined
          }
          diasAdelante={
            this.props.calendario
              ? this.props.calendario.diasAdelante
              : undefined
          }
          showTurnero={this.state.showTurnero}
          disabledPagar={this.state.disabledPagar}
          domicilioSeleccionado={this.state.domicilioSeleccionado}
          domicilioSeleccionadoItem={this.state.domicilioSeleccionadoItem}
          domicilios={
            this.props.usuario
              ? this.props.usuario.domiciliosEntrega
              : undefined
          }
          handleChangeRadioButtonDomicilio={
            this.handleChangeRadioButtonDomicilio
          }
          handleAfterSaveNuevoDomicilio={this.handleAfterSaveNuevoDomicilio}
          handleOnClickCambiarPreferencia={this.handleOnClickCambiarPreferencia}
          handleOnClickDia={this.handleOnClickDia}
          handleOnClickHorario={this.handleOnClickHorario}
          handleOnClickCambiarFechaHora={this.handleOnClickCambiarFechaHora}
          handleOnClickCambiarDomicilio={this.handleOnClickCambiarDomicilio}
          handleOnClickBtnEntrega={this.handleOnClickBtnEntrega}
          handleOnClickEntendido={this.handleOnClickEntendido}
          handleOnClickEntendidoFromCompraFallida={
            this.handleOnClickEntendidoFromCompraFallida
          }
          handleOnClickBackToCatalogo={this.handleOnClickBackToCatalogo}
          handleOnDataChange={this.handleOnDataChange}
          handleOnDataChangeMercadoPago={this.handleOnDataChangeMercadoPago}
          handleOnSaveDatosAdicionales={this.handleOnSaveDatosAdicionales}
          handleOnPagar={this.handleOnPagar}
          handleChangeRadioButton={this.handleChangeRadioButton}
          handleOnClickBtnFormaPago={this.handleOnClickBtnFormaPago}
          handleOnClickFinalizarCompra={this.handleOnClickFinalizarCompra}
          handleChangeRadioButtonIndividual={
            this.handleChangeRadioButtonIndividual
          }
          handleOnClickVerMasPedidosDetalle={
            this.handleOnClickVerMasPedidosDetalle
          }
          // renderMobbexButton={this.renderMobbexButton}
          sucursalesPickup={this.state.sucursalesPickup}
          sucursalPickupSeleccionada={this.state.sucursalPickupSeleccionada}
          handleOnChangeSucursalPickup={(e) =>
            this.handleOnChangeSucursalPickup(e.target.value)
          }
        />
        <div>
        <CustomPaymentDialog
          open={this.state.openCustomDialog}
          onClose={this.handleCloseCustomDialog}
          pedidoId={pedidoId}
          pedidoPrecioFinal={pedidoPrecioFinal}
          pedidoData={this.props.dataPedido.pedido}
          onPaymentSuccess={this.handlePaymentSuccess}
          idFormaEntrega={this.state.entregaElegida}
          dataUser={this.props.usuario}
        />
        </div>
        <div>
          {this.state.isDataLoaded && this.state.localidadesCargadas && (
                <ModalSolicitudLocalidadEntrega
                  open={this.state.openModalSolicitudLocalidadEntrega}
                  onClose={this.handleCloseModal}
                  localidadesEntrega={this.state.localidadesEntregaActivas}
                  onSelectLocation={this.handleSelectLocation}
                  initialSelectedLocation={this.state.localidadSeleccionada}
                  errorMessage={this.state.errorLocalidad}
                  onConfirm={this.handleSubmitLocalidad}
                  domicilioPreferenciaCliente={this.state.domicilioPreferenciaCliente}
                  updateLocalidadEntregaCliente={updateLocalidadEntregaCliente}
                  onSuccess={({ select, item }) => {
                    this.procesarSeleccionDomicilio(select, item);
                  }}
                  actualizarDataUser={this.props.sagaFetchUsuarioLogeado}
                />
          )}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...layoutActions,
      ...pedidoActions,
      ...sessionActions,
      ...provLocActions,
      ...tuerneroActions,
      ...catalogoActions,
      ...confirmarPedidoActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    usuario: usuarioSelector(state),
    instalacion: instalacionSelector(state),
    dataPedido: pedidoDataSelector(state),
    flagDatosAdicionales: flagDatosAdicionalesSelector(state),
    calendario: calendarioSelector(state),
    sucursales: sucursalesSelector(state),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinalizarCompraContainer);
